export const AUTH_TOKEN_URL = process.env.AUTH_TOKEN_URL as string;
export const API_URL = process.env.API_URL_V3 as string;
